import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import DealerCostAndMarginDetails from "./dealerCostAndMarginDetails";

function mapStateToProps(state) {
  return {
    bids: state.bids,
    transactions: state.transactions,
    actionType: state.actionType,
    texts :state.translatedTexts
  };
}

function mapDispatchToProps(dispatch) {
  let actionDispatchers = bindActionCreators(actionCreators, dispatch);
  return actionDispatchers;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DealerCostAndMarginDetails);
